import type { ReactElement } from "react";

import type { ITableProps } from "@similarweb/pro-logic-components";
import { Table } from "@similarweb/pro-logic-components";

import { DEFAULT_NO_DATA_VIEW } from "./const";
import { StyledTableWrapper } from "./styles";

type Props<T extends object> = Pick<
    ITableProps<T>,
    | "data"
    | "columnConfig"
    | "expandable"
    | "isLoading"
    | "children"
    | "pagination"
    | "selection"
    | "loaderRowCount"
    | "onSort"
    | "noData"
    | "rowSelection"
    | "withArrowButtons"
    | "footer"
    | "components"
    | "highlightedRowSelector"
    | "activeRowSelector"
    | "virtual"
    | "scroll"
    | "onScroll"
    | "sticky"
>;

export const SearchResultsTable = <T extends object>(props: Props<T>): ReactElement => {
    return (
        <StyledTableWrapper hasNoData={props.data?.length === 0}>
            <Table
                {...props}
                withArrowButtons={false}
                noData={props.noData || DEFAULT_NO_DATA_VIEW}
            />
        </StyledTableWrapper>
    );
};
